import { Box, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import CaseDedupListTable from "../../../Components/AdminComponents/caseDedup/CaseDedupListTable";
import LoadingSpinner from "../../../LoadingSpinner";

const CaseDedupMain = () => {
  const [records, setRecords] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    fetch(`/api/getcaseDedupList`)
      .then((response) => response.json())
      .then((data) => {
        setRecords(data);
        setIsLoading(false);
      })
      .catch((error) => setIsLoading(false));
  }, []);

  return (
    <Box m={1}>
      {isLoading && <LoadingSpinner />}
      {!isLoading && records?.length > 0 && (
        <>
          <CaseDedupListTable data={records} />
        </>
      )}
      {!isLoading && records?.length < 1 && (
        <Text textAlign="center" fontSize="lg">
          No data found!
        </Text>
      )}
    </Box>
  );
};

export default CaseDedupMain;
